<template>
		<div class="row">
			<div class="col-xl-8 col-lg-10 col-md-12 col-sm-12 col-xs-12">
				<card class="card" title="Edit profile">
					<loader :loading="loading_user">
						<form @submit.prevent>
							<div class="row">
								<div class="col-xl-6 col-lg-6">
									<fg-input type="text"
														label="Username"
														placeholder="Username"
														:class="{'has-error':$v.user.username.$error}"
																		v-model="$v.user.username.$model">
									</fg-input>
								</div>
								<div class="col-xl-6 col-lg-6">
									<fg-input type="password"
														label="Password"
														placeholder="Password"
														:class="{'has-error':$v.user.password.$error}"
																		v-model="$v.user.password.$model">
									</fg-input>
								</div>
							</div>
							<template name="footer">
								<div class="row mt-4">
									<div class="col-12 text-right">
										<p-button v-if="isModified" type="success"
															round
															@click.native.prevent="saveUser" :loading="loading_save">
											Save
										</p-button>
									</div>
								</div>
							</template>
						</form>
					</loader>
				</card>
			</div>
		</div>
</template>
<script>

import {required,requiredIf,minLength} from 'vuelidate/lib/validators';

export default {
	data(){
		return{
			user:{},
			current_username:null,
			loading_user:false,
			loading_save:false
		}
	},
	computed:{
		isModified(){
			return this.$v.user.$anyDirty;
		},
	},
	validations:{
		user:{
			username:{required},
			password:{
				required:requiredIf(function(){
					return this.user.password!=null && this.user.password!=''
				}),
				minLength: minLength(4)
			}
		}
	},
	methods:{
		async loadUser(){
			this.loading_user = true;
			let result = await this.$api.get('user/self');
			this.user = result.data;
			this.user.password = null;
			this.current_username = result.data.username;
			this.loading_user = false;
		},
		async existUsername(){
			let result = await this.$api.get('user/s/exist-username/'+this.user.username);
			return result.data;
			/*let result = await this.$api.get('user?where=username='+this.user.username);
			if(result.data.length>0){
				return result.data[0].username;
			}
			else{
				return null;
			}*/
		},
		async saveUser(){
			this.$v.user.$touch();
			this.loading_save = true;
			if(await this.existUsername()==0 || this.user.username===this.current_username){
				if(!this.$v.user.$invalid){
					
					await this.$api.put('user/self',this.user);
					this.loading_save = false;
					this.$toast.success({
						message:'Profile saved',
						icon: "ti-check",
					});
					this.user.password = null;
					this.$v.user.$reset();
				}
				else{
					this.$toast.error({
						message:'Some fields must be completed',
						icon: "ti-face-sad",
					})
				}
			}
			else{
				this.$toast.error({
					message:'Username exist',
					icon: "ti-face-sad",
				})
			}
			this.loading_save = false;
		}
	},
	async beforeMount(){
		await this.loadUser();
	}
};
</script>
<style>
</style>
